import React from 'react'
import PropTypes from 'prop-types';

import Text from '../../form/form-text'
import Textarea from '../../form/form-textarea'

class ModuleText extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            data: this.props,
            disabled: this.props.disabled
        }
        this.i18n = 'app.modules.components'
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({disabled: nextProps.disabled})
    }

    render() {
        let { text, title } = this.state.data;
        let { disabled } = this.state;

        //FIXME: text => WYSIWYG
        return <div className="module-bitmovin">
            <Text disabled={disabled} label={'app.title'} value={title} />
            <Textarea disabled={disabled} label={'app.description'} value={text} />
        </div>;
    }
}

ModuleText.propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool, // souhld be .isRequired,
    isCustom: PropTypes.bool, // souhld be .isRequired,,
    title: PropTypes.string,
    text: PropTypes.string
}

export default ModuleText;

